<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-13_beirut-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-13_beirut-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.9529147517548;"
    data-aspect-ratio="0.953"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-13_beirut-xs-img"
      class="g-post-13_beirut-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_beirut-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.332%;margin-top:-23.1px;left:3.0223%;width:89px;"
    >
      <p class="g-pstyle1">Area under</p>
      <p class="g-pstyle1">evacuation</p>
      <p class="g-pstyle1">order</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.1598%;margin-top:-8.1px;left:19.5784%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle4">2km</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.6322%;margin-top:-8.1px;left:44.4882%;width:59px;"
    >
      <p class="g-pstyle0">Beirut</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:65.2836%;margin-top:-8.1px;left:50.8916%;width:88px;"
    >
      <p class="g-pstyle2">Haret Hreik</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:76.8341%;margin-top:-8.1px;left:41.2386%;width:124px;"
    >
      <p class="g-pstyle2">Bourj al-Barajneh</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:84.6307%;margin-top:-8.1px;left:65.9192%;width:66px;"
    >
      <p class="g-pstyle2">Hadath</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:53.1556%;margin-top:-8.1px;left:39.6005%;width:62px;"
    >
      <p class="g-pstyle2">Chiyah</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:60.6634%;margin-top:-10.1px;left:86.1454%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle3">Airstrikes</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-13_beirut-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.07065495127509;"
    data-aspect-ratio="1.071"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-13_beirut-sm-img"
      class="g-post-13_beirut-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_beirut-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.1913%;margin-top:-24.7px;left:1.9672%;width:99px;"
    >
      <p class="g-pstyle1">Area under</p>
      <p class="g-pstyle1">evacuation</p>
      <p class="g-pstyle1">order</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.3816%;margin-top:-7.6px;left:15.3416%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle4">2km</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.0814%;margin-top:-7.6px;left:36.7419%;width:59px;"
    >
      <p class="g-pstyle0">Beirut</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:66.4606%;margin-top:-7.6px;left:42.2402%;width:88px;"
    >
      <p class="g-pstyle2">Haret Hreik</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:77.7969%;margin-top:-7.6px;left:33.9516%;width:124px;"
    >
      <p class="g-pstyle2">Bourj al-Barajneh</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:85.1446%;margin-top:-7.6px;left:55.1436%;width:66px;"
    >
      <p class="g-pstyle2">Hadath</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:54.9143%;margin-top:-7.6px;left:32.545%;width:62px;"
    >
      <p class="g-pstyle2">Chiyah</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:62.393%;margin-top:-10.2px;left:65.3604%;width:92px;"
    >
      <p class="g-pstyle3">Airstrikes</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-13_beirut-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 1199px;aspect-ratio: 1.26009642466673;"
    data-aspect-ratio="1.26"
    data-min-width="660"
    data-max-width="1199"
  >
    <div
      id="g-post-13_beirut-md-img"
      class="g-post-13_beirut-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_beirut-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.08%;margin-top:-29.2px;left:4.7329%;width:104px;"
    >
      <p class="g-pstyle1">Area under</p>
      <p class="g-pstyle1">evacuation</p>
      <p class="g-pstyle1">order</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.1614%;margin-top:-10.7px;left:15.9375%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle4">2km</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.4372%;margin-top:-15.4px;left:34.2116%;width:78px;"
    >
      <p class="g-pstyle0">Beirut</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:68.0002%;margin-top:-12.2px;left:38.8724%;width:98px;"
    >
      <p class="g-pstyle2">Haret Hreik</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:79.2646%;margin-top:-12.2px;left:31.8463%;width:139px;"
    >
      <p class="g-pstyle2">Bourj al-Barajneh</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:86.7107%;margin-top:-12.2px;left:49.8108%;width:72px;"
    >
      <p class="g-pstyle2">Hadath</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:56.3538%;margin-top:-12.2px;left:30.6539%;width:67px;"
    >
      <p class="g-pstyle2">Chiyah</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:63.8077%;margin-top:-10.2px;left:58.559%;width:92px;"
    >
      <p class="g-pstyle3">Airstrikes</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post-13_beirut-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post-13_beirut-xl-img"
      class="g-post-13_beirut-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-13_beirut-xl.jpg);"
    ></div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle2">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle3">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:57.4458%;margin-top:-12.2px;left:21.3798%;width:98px;"
    >
      <p class="g-pstyle1">Haret Hreik</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:66.9619%;margin-top:-12.2px;left:17.5155%;width:139px;"
    >
      <p class="g-pstyle1">Bourj al-Barajneh</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:73.2523%;margin-top:-12.2px;left:27.3959%;width:72px;"
    >
      <p class="g-pstyle1">Hadath</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:47.6071%;margin-top:-12.2px;left:16.8596%;width:67px;"
    >
      <p class="g-pstyle1">Chiyah</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-06 16:38 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-06 16:38 -->
<!-- ai file: post-13_beirut.ai -->
<style lang="scss">
  #g-post-13_beirut-box {
    container-type: inline-size;
    container-name: g-post-13_beirut-box;
  }
  #g-post-13_beirut-box,
  #g-post-13_beirut-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-13_beirut-box p {
    margin: 0;
  }
  #g-post-13_beirut-box .g-aiAbs {
    position: absolute;
  }
  #g-post-13_beirut-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-13_beirut-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-13_beirut-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-13_beirut-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-13_beirut-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-13_beirut-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-13_beirut-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 1199px) {
      #g-post-13_beirut-md {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post-13_beirut-xl {
        display: block !important;
      }
    }
  }
  #g-post-13_beirut-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_beirut-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_beirut-xs .g-pstyle0 {
    font-weight: 700;
    height: 15px;
    padding-bottom: 8px;
  }
  #g-post-13_beirut-xs .g-pstyle1 {
    font-weight: 700;
    height: 15px;
    color: rgb(26, 49, 95);
  }
  #g-post-13_beirut-xs .g-pstyle2 {
    font-weight: 400;
    height: 15px;
    padding-bottom: 8px;
  }
  #g-post-13_beirut-xs .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    text-align: center;
    color: rgb(161, 54, 48);
  }
  #g-post-13_beirut-xs .g-pstyle4 {
    font-weight: 400;
    height: 15px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post-13_beirut-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_beirut-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_beirut-sm .g-pstyle0 {
    font-weight: 700;
    height: 14px;
    padding-bottom: 10px;
  }
  #g-post-13_beirut-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
    color: rgb(26, 49, 95);
  }
  #g-post-13_beirut-sm .g-pstyle2 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 10px;
  }
  #g-post-13_beirut-sm .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
    color: rgb(161, 54, 48);
  }
  #g-post-13_beirut-sm .g-pstyle4 {
    font-weight: 400;
    height: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post-13_beirut-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_beirut-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 23px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_beirut-md .g-pstyle0 {
    font-weight: 700;
    line-height: 29px;
    height: 29px;
    padding-bottom: 12px;
    font-size: 21px;
  }
  #g-post-13_beirut-md .g-pstyle1 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
    color: rgb(26, 49, 95);
  }
  #g-post-13_beirut-md .g-pstyle2 {
    font-weight: 400;
    height: 23px;
    padding-bottom: 12px;
  }
  #g-post-13_beirut-md .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
    color: rgb(161, 54, 48);
  }
  #g-post-13_beirut-md .g-pstyle4 {
    font-weight: 400;
    line-height: 20px;
    height: 20px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post-13_beirut-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-13_beirut-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 23px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-13_beirut-xl .g-pstyle0 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-13_beirut-xl .g-pstyle1 {
    font-weight: 400;
    height: 23px;
    padding-bottom: 12px;
  }
  #g-post-13_beirut-xl .g-pstyle2 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-post-13_beirut-xl .g-pstyle3 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      -1px 0 rgba($clr, $alpha),
      0 1px rgba($clr, $alpha),
      1px 0 rgba($clr, $alpha),
      0 -1px rgba($clr, $alpha);
  }
  .gshadowtext {
    @include shadow-emmental(#ffffff);
  }
  p[class^='g-pstyle'] {
    @include shadow-emmental(#ffffff);
  }
</style>
